import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The old leads inbox (specs 019 and 020), later the lead pool: gone since ADR 0019. Old links
 * and bookmarks land on the pipeline.
 */
export const Route = createFileRoute('/_app/deals/leads')({
  beforeLoad: () => {
    throw redirect({ to: '/deals', search: {}, replace: true });
  },
});
